// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u0v77o{margin-left:var(--ds-space-025,2px)}\n._1nmz9jpi{word-break:break-all}\n._o5721jtm{white-space:pre-wrap}\n._s7n41q9y{vertical-align:baseline}", ""]);
// Exports
module.exports = exports;
